import { ApiManager } from '../../core/api-manager';
import { settings } from '../../config/settings';
import { LanguageProvider } from '../../core/language-provider';
import { toast } from 'react-toastify';
import { DataManager } from '../../core/data-manager';
import { useNavigate } from 'react-router-dom';


export const actions = {
    DataGridRow: {
        sample: [
            {
                label: "Test",
                icon: "share",
                func: test
            }
        ],
        customer: [
            {
                label: "Nascondi",
                icon: "trash",
                func: hideCustomer,
            }
        ]
    },
    ModalDetailsFooter: {
        sample: [
            {
                label: "Test",
                icon: "share",
                func: test
            }
        ]
    }
}

function test(item) {
    console.warn("test", item)
}

async function hideCustomer(item, navigate) {
    var data = {
        visible: 0
    }
    var response = await DataManager.updateItem('customer', data, item.id);
    if (response.success === 1) {
        toast.success('Cliente nascosto con successo!', { theme: 'colored' });
        navigate(0);
    }
    else {
        toast.error('Errore nel nascondere il cliente', { theme: 'colored' });
    }
}